export class UserPerms {
	public static readonly DELETE = 'DELETE';
	public static readonly EDIT = 'EDIT';
	public static readonly SHARE = 'SHARE';
	public static readonly VIEW = 'VIEW';
	public static readonly TRANSFER = 'TRANSFER';


	private _permissions = new Set([]);
	constructor(permissions: string[]) {
		if (permissions) {
			this._permissions = new Set(permissions);
		}
	}

	public hasEditPerms(): boolean {
		return this._permissions.has(UserPerms.EDIT);
	}
}
